import { WorkBuddyDialogService } from '@workbuddy/ui/v2/blocks/dialog';
import type { JobTemplateQuestionBoardParams } from '../../job.template.question.model';
import { JobTemplateQuestionVisibilityComponent } from './question.visibility.component';

/** One opener for the two places that reach the rule: the Show Condition cell and the row menu. */
export function openJobTemplateQuestionVisibilityDialog(dialogs: WorkBuddyDialogService, params: JobTemplateQuestionBoardParams, questionId: string): void {

  void dialogs.modal(JobTemplateQuestionVisibilityComponent, {
    inputs: { template: params.template(), questionId, questionsChanged: params.questionsChanged },
    width: 'min(520px, calc(100vw - 48px))',
    height: 'min(380px, calc(100vh - 48px))',
  });
}
